import * as z from "zod/v4";

export const updateErrorMessage = {
  name: "updateErrorMessage" as const,
  input: z.object({
    originalType: z.enum(["terminal", "retryable"]),
    originalRawErrorMessage: z.string(),
    type: z.enum(["terminal", "retryable"]),
    rawErrorMessage: z.string(),
    prettyErrorMessage: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
